module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'successo',
    selected: 'Selezionato',
    chooseGiftFirst: 'Seleziona prima una carta regalo: Apple o Starbucks.',
    综合评价: "Valutazione Complessiva",
    inputNotSame: "Input Non Uguale",
    example: 'Esempio',
    "btnPrev": "Precedente",
    // 选择语言
    popupTitle: 'Seleziona lingua',
    // 发送
    send: 'Confermare',
    // 发送邮件
    sendEmail: 'Invia e-mail',
    // 改变语言
    changeLanSes: 'Cambio lingua riuscito',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: 'La voce degli acquirenti',
    // 系统解释
    details: 'Ascoltiamo la voce degli acquirenti e offriamo prodotti e servizi di qualità.\nGrazie per essere con noi!',
    fileSizeOver: "Il file è troppo grande, sono supportate solo immagini entro 10MB.",
    lowTextarea: 'Il vostro feedback ci aiuterà a migliorare continuamente i nostri prodotti e servizi.',
    placeholderOrderNo: "Inserire il numero d'ordine (formato: 000-0000000-0000000)",
    "picUploadSuccessText": "Immagine caricata con successo",
    "picUploadErrorText": "Caricamento immagine fallito",
    "orderNotExistText": "L'ordine non esiste",
    "orderInvalidText": "Questo ordine è invalido",
    "networkErrorText": "Errore di rete",
    "orderErrorText": "Errore nell'ordine",
    // step1
    formBasic: {
        confirm_btn: "Conferma",
        "order_help_title": "Assistenza numero d'ordine",
    "order_help_content": "Se non conosci il tuo numero d'ordine, ti preghiamo di contattarci per scoprire come ottenerlo. La nostra e-mail: ",
        form_code: 'Codice di verifica',
        form_code_placeholder: 'Inserisci il codice di verifica',
        "get_code": "Ottieni il codice",
  "code_sent_success": "Codice inviato con successo",
        "platform_name": "Nome della piattaforma",
        "platform_name_placeholder": "Per favore, seleziona una piattaforma",
  "form_name_placeholder": "Inserisca il suo nome",
        title: 'Registra la tua garanzia e<br><span style="color:#C9A127">richiedi il tuo regalo misterioso</span>',
        form_name: 'Name',
        form_email: 'Email',
        form_email_note: 'per la consegna del regalo e l’assistenza',
        form_order: "Numero d'ordine",
        form_order_error_placeholder: "Inserire il numero d'ordine (formato: 000-0000000-0000000)",
        order_why: `*Come trovare il numero dell'ordine?`,
        order_answer: `*Non condividiamo le vostre informazioni personali con nessuno.
Le informazioni personali sono protette e utilizzate esclusivamente per l'attivazione della garanzia.`,
        btn_text: 'Attiva ora',
        "form_name_placeholder": "Per favore inserisci il tuo nome",
        "form_email_placeholder": "Per favore inserisci la tua email",
        "form_email_error_placeholder": "Per favore inserisci una email valida",
        "form_order_placeholder": "Per favore inserisci il tuo numero d'ordine"
    },
    // step2
    showGiftCard: {
        title: 'La garanzia estesa è attiva.<br>Abbiamo aggiunto <strong>9 mesi</strong> di copertura al tuo prodotto.<br>Grazie per il tuo acquisto!',
        text: '🎁 Richiedi la tua gift card da 20 $ e condividi la tua esperienza<br><small>(Meno di 1 minuto)</small>',
        gift_card_text: 'Scegli la tua gift card elettronica da 20 $',
        btn_text: 'Ottieni la mia ricompensa'
    },
    // step3
    expectations: {
        title: "Grazie per aver scelto i nostri prodotti e servizi!",
        text: "Se soddisfa le tue aspettative o ti regala una piccola sorpresa, perché non dedicare qualche secondo a lasciare una recensione positiva sul sito di acquisto? Lascia una recensione positiva e ricevi una carta regalo da 10$!",
        btn_text: "Passaggio successivo"
    },
    // step3
    star: {
        title: 'Sei soddisfatto di questo prodotto o del nostro servizio?',
        text: 'Assegna una valutazione a stelle al prodotto qui sotto:',
        star__placeholder: 'Si prega di valutare tutte le domande prima di inviare!',
        written: 'Aggiungi una recensione scritta: <span style="color:#F40000">(Opzionale)</span>',
        written_placeholder: 'Cosa ti è piaciuto? Per cosa hai usato questo prodotto?',
        btn_text: 'Passo successivo'
    },
    // step4
    ensureEmail: {
        title: `Congratulazioni!</br>
Hai terminato il sondaggio.
`,
        text: `Confermate due volte l'indirizzo e-mail, riceverete il codice regalo tramite questo indirizzo e-mail:
customerservice8@yeah.net`,
        email_placeholder: "Si prega di confermare nuovamente l'email!",
        btn_text: 'Confermare'
    },
    // step5
    reviewGuide: {
        title: 'Come lasciare una recensione sulla piattaforma di acquisto',
        subtitle: 'Seleziona la piattaforma per visualizzare i passaggi.'
    },
    channelSelect: {
        title: `Il tuo feedback è importante!`,
        text: `Grazie per aver lasciato il tuo prezioso feedback! Ora puoi scegliere il regalo che desideri!!!`,
        footer: `*Circa il regalo:</br>
Nessuna spesa di spedizione, nessuna spesa nascosta, nessuna carta di credito richiesta`,
        btn_text: 'Lo voglio'
    },
    // step6
    uploadPic: {
        guideText: 'Hai bisogno di aiuto per fare uno screenshot?<br><small>Seleziona qui sotto la piattaforma di acquisto per una guida rapida.</small>',
        "title": "Carica uno screenshot della tua esperienza con il prodotto.",
  "text": "Per richiedere la tua gift card da 20 $, invia semplicemente qui sotto uno screenshot<br>della recensione che hai pubblicato.",
        add_pic: 'Fai clic per caricare o trascina qui',
        add_pic_text: 'JPG / PNG, fino a 10 MB',
        btn_text: 'Invia e richiedi il regalo',
        uploading: 'Caricamento... Si prega di attendere',
        upload_required: 'Carica uno screenshot prima di continuare.',
        "no_file_selected": "Nessun file selezionato"
    },
    // step7
    cityForm: {
        title: `*Indirizzo di ricezione dell'accessorio: `,
        text: `(Confermare l'indirizzo di spedizione, l'omaggio sarà organizzato in 3-5 giorni lavorativi).`,
        form_city: 'Città',
        form_state: 'Stato/Regione',
        form_postal_code: 'Codice postale',
        form_country: 'Paese',
        btn_text: 'Confermare',
        "form_city_placeholder": "Per favore inserisci la tua città",
        "form_state_placeholder": "Per favore inserisci la tua zona",
        "form_postal_code_placeholder": "Per favore inserisci il tuo CAP",
        "form_country_placeholder": "Per favore inserisci il tuo paese"
    },
    // step7
    paypalForm: {
        title: 'Dove dobbiamo inviare la tua gift card da 20 $?',
        text: '(Assicurati che i dati PayPal siano corretti per evitare ritardi.)',
        form_paypal: 'Account PayPal',
        form_ensure_paypal: 'Conferma account PayPal',
        form_paypal_name: 'Nome dell’intestatario dell’account PayPal',
        btn_text: 'Confermare',
        "form_paypal_placeholder": "Per favore inserisci il tuo account PayPal",
        "form_ensure_paypal_placeholder": "Per favore conferma il tuo account PayPal",
        "form_paypal_name_placeholder": "Per favore inserisci il tuo nome PayPal"
    },
    // thanks-all
    thanksAll: {
        doneTitle: 'Fatto! 🎉', doneDescription: 'Abbiamo ricevuto il tuo screenshot! La tua richiesta di gift card è in elaborazione.',
        request: 'Richiesta carta regalo', processing: 'In elaborazione', deliveryPrefix: 'Consegna stimata:', deliveryTime: '1-2 giorni lavorativi', deliverySuffix: 'via email.',
        rewardTitle: 'Il tuo premio', rewardDescription: 'Una carta regalo elettronica da 20 $ sarà inviata alla tua email.',
        verifyStep: 'Verificheremo il tuo screenshot entro 1-2 giorni lavorativi.', approvedStep: 'Una volta approvata, la gift card ti verrà inviata via email.', spamStep: 'Ricordati di controllare la cartella spam/posta indesiderata.', supportText: 'Domande? Contatta il nostro team di supporto all’indirizzo',
        "title": "Grati per il tuo contributo!",
        // title_desc1: 'Grazie per aver partecipato al nostro sondaggio sui prodotti!',
        // title_desc2: 'projector survey!',
        text: `Le vostre preziose opinioni ci aiuteranno a migliorare la qualità dei prodotti. 
Se avete domande durante l'uso, non esitate a contattarci.`
    },
    // thanks
    thanks: {
        "title": "Congratulazioni!",
        title_desc1: `La garanzia è stata attivata!
Grazie mille per il vostro tempo.`,
        title_default_paypal_desc1: `La garanzia è stata attivata!
Grazie mille per il vostro tempo. Il tuo premio verrà erogato entro 24-72 ore.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
